import React from 'react';
import Dropdown from '../Dropdown/Dropdown';

import Moment from 'moment';
import { extendMoment } from 'moment-range';
const moment = extendMoment(Moment);

export default class YearPicker extends React.Component {
    constructor(props) {
        super(props);

        const range = moment.range(this.props.startDate, this.props.endDate);
        const years = Array.from(range.reverseBy('year'))
            .map(x => x.format('YYYY'))
            .map(x => {
                return {
                    value: x,
                    label: x
                }
            });

        this.state = {
            items: years
        }
    }

    render() {

        return (
            <Dropdown
                items={this.state.items}
                placeholder={this.props.placeholder || 'Select Year'}
                name={this.props.name}
                styleClass={this.props.styleClass}
                onSelect={this.props.onSelect}
                isInvalid={this.props.isInvalid}
                selectedValue={this.props.selectedValue}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./Src/Appointment/AppointmentScheduler/YearPicker/YearPicker.jsx